(function() {
    'use strict';

    angular.module('remitEventsApp').service('DictionariesService', function() {
        this.generateDictionary = function(values, nlsCode, idAtIndex) {
            var dictionaries = [];

            for (var i = 0; i < values.length; i++) {
                dictionaries.push({
                    id: idAtIndex ? i : values[i],
                    label: nlsCode ? nlsCode + '.' + values[i] : values[i]
                });
            }

            return dictionaries;
        };

        this.getGranulations = function() {
            return this.generateDictionary(['DAY', 'WEEK', 'MONTH', 'YEAR'], 'remitEventsApp.graph.granulation');
        };

        this.getYears = function() {
            var years = [];

            for (var year = 2011; year <= 2019; year++) {
                years.push(year);
            }

            return this.generateDictionary(years);
        };

        this.getMonths = function() {
            return this.generateDictionary(
                ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                'remitEventsApp.graph.granulation.months',
                true
            );
        };
    });
})();
